<!-- 部门信息组件 -->
<template>
  <div class="body">
    <el-popover trigger="hover" placement="right" width="400" @show="showPopover">
      <div>
        <el-descriptions class="margin-top" title="部门信息" :column="2" size="small" border>
          <el-descriptions-item v-if="deptInfo.deptName">
            <template slot="label">
              部门名称
            </template>
            {{ deptInfo.deptName }}
          </el-descriptions-item>
          <el-descriptions-item v-if="deptInfo.deptManager">
            <template slot="label">
              部门领导
            </template>
            {{ deptInfo.deptManager }}
          </el-descriptions-item>
          <el-descriptions-item v-if="deptInfo.deptLeader">
            <template slot="label">
              部门经理
            </template>
            {{ deptInfo.deptLeader }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="reference">{{ deptName }}</span>
    </el-popover>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    deptId: {
      // 部门id
      type: String,
      required: true
    },
    deptName: {
      // 部门Name
      type: String,
      required: true
    }
  },
  data() {
    return {
      deptInfo: {} // 部门信息
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId
    })
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {
    showPopover() {
      if (!this.deptId) return;
      const inFo = {
        deptName: "产品研究院",
        deptManager: "刘晓东",
        deptLeader: "钟玉亮"
      };
      this.deptInfo = inFo;
    }
  }
};
</script>

<style scoped lang="scss">
.body {
  width: 100%;
  display: flex;
  // justify-content: center;
  align-items: center;
}
</style>
